import React from 'react';
import PropTypes from 'prop-types';

const ModalBody = ({videoUrl}) => (
    <div className="selling-proposition-modal-body">
        <video width="100%" height="100%" controls autoPlay>
            <source src={videoUrl} type="video/mp4"/>
        </video>
    </div>
);

ModalBody.propTypes = {
    videoUrl: PropTypes.string
};

export default ModalBody;
